Customer.Dashboard ||= {}

class Customer.Ticket.MassiveSelectedTicketsView extends Backbone.View
  template: JST["backbone/templates/customer/dashboard/summary/main/header/massive_selected_tickets"]

  events:
    'click #select-not-loaded': 'onSelectNotLoaded'

  initialize: (@options = {}) ->
    @total = @options.total
    @totalLoaded = @options.totalLoaded
    @loadedSelectedTickets = @options.loadedSelectedTickets
    @loadedUnselectedTickets = @totalLoaded - @loadedSelectedTickets
    @notLoadedTickets = @total - @loadedSelectedTickets
    @includeNotLoaded = @options.includeNotLoaded
    @allSelected = @includeNotLoaded || @loadedUnselectedTickets == 0

  render: ->
    if @allSelected
      notLoadedCount = @notLoadedTickets
    else
      notLoadedCount = @loadedUnselectedTickets

    @$el.html(
      @template(
        loadedCount: @loadedSelectedTickets
        notLoadedCount: notLoadedCount
      )
    )

    @updateLink(@selectAllLink()) unless @allSelected
    @updateMessages(@total) if @includeNotLoaded
    @

  onSelectNotLoaded: (event) ->
    @_keepCustomerSessionAlive()
    event.preventDefault()
    if @allSelected
      @updateMessages(@total)
      @trigger 'summary:massive:select:not:loaded'
    else
      @updateSelectAllValues(@totalLoaded, @loadedSelectedTickets)
      @updateText(@allLoadedSelectedText(@loadedSelectedTickets))
      @updateLink(@selectNotLoadedLink())
      @trigger 'summary:massive:select:all'

  updateSelectAllValues: (total, selected) ->
    @loadedSelectedTickets = selected
    @loadedUnselectedTickets = total - selected
    @totalLoaded = total
    @notLoadedTickets = @total - selected
    @allSelected = @loadedUnselectedTickets == 0

  updateSelectLoaded: (total, selected) ->
    @updateSelectAllValues(total, selected)
    @updateText(@allLoadedSelectedText(@loadedSelectedTickets))
    if @allSelected
      @updateLink(@selectNotLoadedLink(@notLoadedTickets))
    else
      @updateLink(@selectAllLink())

  updateSelectNotLoaded: ->
    @updateMessages(@total)

  updateMessages: (value) ->
    @updateText(@allTicketsSelectedText(value))
    @updateLink("")

  updateText: (text) ->
    @$el.find(".massive-selected-tickets-text").text(text)

  updateLink: (text) ->
    @$el.find(".massive-selected-tickets-link").text(text)

  allLoadedSelectedText: (value) ->
    I18n.t('customer.dashboard.conversations.multiple.loaded_selected_tickets', tickets: value)

  allTicketsSelectedText: (value) ->
    I18n.t('customer.dashboard.conversations.multiple.all_filter_tickets_selected', tickets: value)

  selectAllLink: ->
    I18n.t('customer.dashboard.conversations.multiple.select_loaded_tickets')

  selectNotLoadedLink: ->
    I18n.t('customer.dashboard.conversations.multiple.select_missing_tickets', tickets: @notLoadedTickets)

  _keepCustomerSessionAlive:->
    Backbone.trigger 'customerSession:keepAlive'
